export default {
    /**
     * Download file from base64 data
     * @param {string} data
     * @param {string} filename
     */
    download(data, filename){
        const downloadUrl = window.URL.createObjectURL(data)
        const a = document.createElement('a')
        a.href = downloadUrl
        a.download = filename
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(downloadUrl)
    }
}
